module.exports = __webpack_public_path__ + "f251dacfc81e1fae769a74cdbd20053d.svg";